import { Stack, Typography } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import React, { useContext } from "react";
import { DashboardContext } from "../../../contexts/DashboardContext";

const useStyles = makeStyles((theme) => ({
    title: {
        fontFamily: 'Poppins',
        fontSize: '1.2rem',
        fontWeight: 'bold',
        color: '#666666',
    },
    subtitle: {
        fontFamily: 'Inter',
        fontSize: '1rem',
        color: theme.colors.neutral['500'],
    },
}));

const CustomFields: React.FC<{}> = () => {
    const classes = useStyles();
    const { dashboard } = useContext(DashboardContext);

    return (<>
        <Stack spacing={2} alignItems="flex-start" justifyContent="flex-start" width="100%" height="100%">
            {dashboard?.customFields?.map(({name, value}, i) => (
                <Stack spacing={2} alignItems="flex-start" justifyContent="flex-start" minHeight={80}
                    key={'custom-fields-61-' + i}>
                    <Typography className={classes.title}>
                        {name}
                    </Typography>
                    <Typography className={classes.subtitle}>
                        {value}
                    </Typography>
                </Stack>
            ))}
        </Stack>
    </>);
}

export default CustomFields;
